import { Action } from './action.interface';
import { IconComponentConfig } from '../icon';

/**
 * Compare two icon configurations
 */
export function isIconEqual(icon1: Action['icon'], icon2: Action['icon']): boolean {
  if (!icon1 && !icon2) {
    return true;
  }
  if (!icon1 || !icon2) {
    return false;
  }
  if (typeof icon1 === 'string' && typeof icon2 === 'string') {
    return icon1 === icon2;
  }
  if (typeof icon1 === 'object' && typeof icon2 === 'object' && icon1 !== null && icon2 !== null) {
    if ('name' in icon1 && 'name' in icon2) {
      return icon1.type === icon2.type &&
             icon1.name === icon2.name &&
             (icon1 as IconComponentConfig).color === (icon2 as IconComponentConfig).color &&
             (icon1 as IconComponentConfig).size === (icon2 as IconComponentConfig).size;
    }
    return JSON.stringify(icon1) === JSON.stringify(icon2);
  }
  return false;
}

/**
 * Compare two actions to check if they are equal
 */
export function isActionEqual(action1: Action | undefined, action2: Action | undefined): boolean {
  if (!action1 && !action2) {
    return true;
  }
  if (!action1 || !action2) {
    return false;
  }
  return action1.name === action2.name &&
         action1.text === action2.text &&
         action1.behavior === action2.behavior &&
         action1.buttonType === action2.buttonType &&
         action1.redirectUrl === action2.redirectUrl &&
         action1.disabled === action2.disabled &&
         action1.tooltipText === action2.tooltipText &&
         action1.emitWithoutPopconfirm === action2.emitWithoutPopconfirm &&
         // eslint-disable-next-line @typescript-eslint/no-explicit-any
         (action1 as any).visible === (action2 as any).visible &&
         isIconEqual(action1.icon, action2.icon);
}

/**
 * Compare two action arrays to check if they are equal
 */
export function areActionsEqual(arr1: Action[], arr2: Action[]): boolean {
  if (!arr1 || !arr2 || arr1.length !== arr2.length) {
    return false;
  }
  return arr1.every((a1, i) => isActionEqual(a1, arr2[i]));
}

